import { mdiContentCopy } from '@mdi/js'

import { useState } from 'react'
import { useIntl } from 'react-intl'
import {
  HomeUIDButton,
  HomeUIDCopy,
  HomeUIDIcon,
  HomeUIDWrapper,
} from '../../HomeStatus/MainInfo/HomeUID/styles'
import { StyledLabel, StyledTitle } from '../../HomeStatus/MainInfo/styles'
import { messages } from '../messages'
import { commonMessages } from 'app/i18n/messages'

interface DeviceUIDProps {
  uid: string
}

function DeviceUID({ uid }: DeviceUIDProps) {
  const { formatMessage } = useIntl()
  const [copied, setCopied] = useState(false)

  const handleClick = async () => {
    await navigator.clipboard.writeText(uid)
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  if (!uid) {
    return null
  }

  return (
    <HomeUIDWrapper>
      <StyledLabel>{formatMessage(messages.deviceUID)}</StyledLabel>
      <HomeUIDCopy>
        <StyledTitle>
          {copied ? formatMessage(commonMessages.copied) : uid}
        </StyledTitle>
        <HomeUIDButton
          onClick={handleClick}
          title={formatMessage(commonMessages.copy)}
        >
          <HomeUIDIcon path={mdiContentCopy} size={1} />
        </HomeUIDButton>
      </HomeUIDCopy>
    </HomeUIDWrapper>
  )
}

export default DeviceUID
